import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Input from "@mui/material/Input";
import { useScreenSize } from "../util/useScreenSize";
import FormControlCheckbox from "../../../themeComponents/FormControlCheckbox";
import styled from "@mui/material/styles/styled";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { makeStyles } from "@mui/styles";

//region [[ Styles ]]
const DesktopSelectWrapper = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  padding: "20px 25px",
  backgroundColor: "#fafafa",
});

const MobileSelectWrapper = styled("div")({
  margin: "12px 16px",
  backgroundColor: "#fafafa",
});

const MobileSelectControl = styled(FormControl)({
  display: "flex",
  justifyContent: "center",
  width: "218px",
  height: "38px",
  margin: "15px 50px",
  border: `0.5px solid ${KahunColorMap.PrimaryDim}`,
  borderRadius: "7px",
});

const MobileSelect = styled(Select)({
  "&::before": { display: "none" },
});

const MobileSelectInput = styled(Input)({
  margin: "12px 16px",
  fontSize: "14px",
  "&:after": {
    borderBottomWidth: 0,
  },
});
const useStyles = makeStyles({
  select: {
    "&:focus": {
      backgroundColor: "white",
    },
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]
interface ExportDataGroupSelectProps {
  activeDataGroups: Record<string, boolean>;
  onCheckboxChange: (name: string, checked: boolean) => void;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const ExportDataGroupSelect = ({
  activeDataGroups,
  onCheckboxChange,
}: ExportDataGroupSelectProps) => {
  const { isMobile } = useScreenSize();
  const classes = useStyles();

  const dataGroups = Object.keys(activeDataGroups);

  return (
    <React.Fragment>
      {isMobile ? (
        <MobileSelectWrapper>
          <MobileSelectControl>
            <MobileSelect
              multiple
              value={
                dataGroups.some((key) => !activeDataGroups[key])
                  ? [""]
                  : ["Select All"]
              }
              renderValue={(selected) => (selected as string[]).join(", ")}
              input={<MobileSelectInput />}
              inputProps={{
                classes: { select: classes.select },
              }}
            >
              {dataGroups.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox
                    checked={activeDataGroups[name]}
                    onChange={(e) => {
                      onCheckboxChange(name, e.target.checked);
                    }}
                  />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </MobileSelect>
          </MobileSelectControl>
        </MobileSelectWrapper>
      ) : (
        <DesktopSelectWrapper>
          {dataGroups.map((name, index) => (
            <FormControlCheckbox
              key={index}
              text={name}
              checked={activeDataGroups[name]}
              onChange={(e, checked) => {
                onCheckboxChange(name, checked);
              }}
            />
          ))}
        </DesktopSelectWrapper>
      )}
    </React.Fragment>
  );
};

export default ExportDataGroupSelect;
